import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "./transition";

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["sidebar", 'innerSidebar', 'shower', 'innerSidebarWrapper']
  static values = {open: { type: Boolean, default: false }}

  openValueChanged() {
    if (this.openValue) {
      enter(this.sidebarTarget)
      enter(this.innerSidebarWrapperTarget)
    } else {
      leave(this.sidebarTarget)
      leave(this.innerSidebarWrapperTarget)
    }
  }

  show() {
    this.openValue = true
  }

  close() {
    this.openValue = false
  }

  // Closes dropdown from outside click or keyboard
  hide(event) {
    if (this.showerTarget.contains(event.target)) { return }
    if (this.openValue && event.target.nodeType && !this.innerSidebarTarget.contains(event.target)) {
      this.openValue = false
    }
  }


}
